<app-spinner
    [show]="showSpinner"
    [text]="spinnerText"
    [type]="'fullscreen'"
    [color]="'#B1476A'" [trackColor]="'#4CA7C8'"
    [blurBackground]="true"
></app-spinner>

<app-page-header icon="local_hospital" title="Centros Médicos" subtitle="Listado de centros médicos del sistema"></app-page-header>

<div *ngIf="flagLoaded" class="profile-area pb-70">
  <div class="container">
    <div class="profile-courses-quizzes">
      <div class="top-actions-bar">
        <a routerLink="/centro-medico-alta">
          <button mat-raised-button mat-button color="secondary">
            <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon> NUEVO CENTRO MÉDICO
          </button>
        </a>
        
        <!-- Botón de filtro por geolocalización -->
        <div class="geo-filter-bar">
          <button mat-raised-button 
                  class="btn-geo-filter" 
                  [class.active]="filtroSinGeo"
                  (click)="filtroSinGeo ? limpiarFiltroGeo() : filtrarSinGeolocalizacion()"
                  [disabled]="buscando || isGeolocating">
            <mat-icon>location_off</mat-icon>
            {{ filtroSinGeo ? 'MOSTRANDO SIN GEOLOCALIZACIÓN' : 'VER CENTROS SIN GEOLOCALIZACIÓN' }}
            <span *ngIf="filtroSinGeo" class="geo-badge">{{ contadorSinGeo }}</span>
          </button>
          
          <!-- Botón de acción masiva -->
          <button *ngIf="contadorSinGeo > 0" 
                  mat-raised-button 
                  color="primary"
                  class="btn-geo-action"
                  (click)="geolocalizarPendientes()"
                  [disabled]="buscando || isGeolocating">
            <mat-icon>send</mat-icon>
            GEOLOCALIZAR CENTROS PENDIENTES ({{ contadorSinGeo }})
          </button>

          <button *ngIf="filtroSinGeo" mat-button class="btn-geo-clear" (click)="limpiarFiltroGeo()">
            <mat-icon>close</mat-icon> Mostrar todos
          </button>
        </div>
      </div>
      <br>
      <hr>
      <div *ngIf="flagLoaded">

        <!-- Sección de filtros en 4 columnas -->
        <div class="filtros-combinados">
          <div class="filtros-row">

            <!-- Columna 1: Planes -->
            <div class="filtro-col">
              <mat-form-field appearance="outline" class="filtro-field">
                <mat-label>Planes</mat-label>
                <mat-select multiple 
                            [(ngModel)]="planesSeleccionadosIds"
                            (selectionChange)="onPlanesChange($event)">
                  <mat-option [value]="null">NINGUNO</mat-option>
                  <mat-option *ngFor="let plan of planesFiltros" [value]="plan._id">
                    {{ plan.denominacion }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Columna 2: Rubro -->
            <div class="filtro-col">
              <mat-form-field appearance="outline" class="filtro-field">
                <mat-label>Rubro</mat-label>
                <mat-select [(ngModel)]="rubroSeleccionadoId" (selectionChange)="onRubroChange($event)">
                  <mat-option value="">NINGUNO</mat-option>
                  <mat-option *ngFor="let rubro of rubros" [value]="rubro._id">
                    {{ rubro.concepto }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Columna 3: Especialidad -->
            <div class="filtro-col">
              <mat-form-field appearance="outline" class="filtro-field">
                <mat-label>Especialidad</mat-label>
                <mat-select [(ngModel)]="especialidadSeleccionadaId" [disabled]="!rubroSeleccionadoId">
                  <mat-option value="">NINGUNA</mat-option>
                  <mat-option *ngFor="let especialidad of especialidadesFiltradas" [value]="especialidad._id">
                    {{ especialidad.concepto }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="!rubroSeleccionadoId">Seleccione un rubro primero</mat-hint>
              </mat-form-field>
            </div>

            <!-- Columna 4: Botones Buscar/Limpiar -->
            <div class="filtro-col botones-col">
              <div class="botones-filtros">
                <button mat-raised-button (click)="aplicarFiltrosCombinados()" [disabled]="buscando">
                  <mat-icon>search</mat-icon>
                  BUSCAR
                </button>
                <button mat-button (click)="limpiarFiltrosCombinados()" [disabled]="buscando">
                  <mat-icon>close</mat-icon>
                  Limpiar
                </button>
              </div>
            </div>
          </div>

          <!-- Leyenda de búsqueda vacía debajo de los filtros -->
          <div class="hint-busqueda-vacia">
            * Si no selecciona ningún filtro, se mostrarán todos los centros.
          </div>

          <!-- Filtro de texto por nombre (debajo de las 4 columnas) -->
          <div class="filtro-texto">
            <mat-form-field>
              <mat-label>Filtrar por nombre</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Centro Médico..." autocomplete="off" #input>
            </mat-form-field>
          </div>
        </div>

        <!-- Mensajes de estado -->
        <div *ngIf="mensajeFiltros" class="mensaje-filtros">
          {{ mensajeFiltros }}
        </div>
        


        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Centro</th>
              <td mat-cell *matCellDef="let element">{{element.nombre || 'SIN DATOS ASOCIADOS'}}</td>
            </ng-container>

            <ng-container matColumnDef="direccion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Dirección</th>
              <td mat-cell *matCellDef="let element">{{element.calle + ' ' + element.altura || 'SIN DATOS ASOCIADOS'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="zona">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zona</th>
              <td mat-cell *matCellDef="let element">{{element.zona?.concepto || 'SIN DATOS ASOCIADOS'}}</td>
            </ng-container>

            <ng-container matColumnDef="localidad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Localidad</th>
              <td mat-cell *matCellDef="let element">{{element.localidad?.nombre || 'SIN DATOS ASOCIADOS'}}</td>
            </ng-container>
              
            <ng-container matColumnDef="planes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Plan </th>
                <td mat-cell *matCellDef="let element">
                  {{element.planesDenominacion || 'SIN PLANES'}}
                  </td>
              </ng-container>
              
            <ng-container matColumnDef="geo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Geo </th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="tieneGeolocalizacion(element)" class="geo-status geo-ok" title="Geolocalizado">
                  <mat-icon class="geo-icon">place</mat-icon>
                </span>
                <span *ngIf="!tieneGeolocalizacion(element)" class="geo-status geo-fail" title="Sin geolocalización">
                  <mat-icon class="geo-icon">location_off</mat-icon>
                </span>
              </td>
            </ng-container>

              <ng-container matColumnDef="activo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
                <td mat-cell *matCellDef="let element">
                    <div class="toggler">
                        <input 
                            type="checkbox" 
                            [id]="'toggler-' + element._id" 
                            [checked]="element.activo || false"
                            (change)="toggleActivo(element, $event)">
                        <label [for]="'toggler-' + element._id"></label>
                    </div>
                </td>
            </ng-container>
              
            <ng-container matColumnDef="_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <button style="margin-right: 5px;" (click)="verCentroMedico(element._id)" type="button"
                    title="Modificar datos del centro médico" class="btn btn-warning">
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
            </ng-container>
              
            <tr class="mat-row" *matNoDataRow="let row; when: noDataFilter">
                <td class="mat-cell" colspan="4">No se encontraron resultados para "{{input.value}}"</td>
            </tr>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row 
                *matRowDef="let row; columns: displayedColumns; when: hasData" 
                [class.inactive-row]="!row.activo"
                class="example-element-row">
            </tr>
          </table>
              
          <mat-paginator [pageSizeOptions]="[50, 100, 150, 200, 500, 800]" aria-label="Select page of campus"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>